import { t } from 'i18next';
import i18next from 'i18next';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccountRegistered: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="col-12">
      <div
        className="flex justify-content-center align-items-center min-h-screen"
        style={{
          margin: 0,
          padding: 0,
          fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
          background: 'linear-gradient(60deg, #13dfb6 0%, #004e78 100%)',
          minHeight: '100vh',
        }}
      >
        <div
          className="flex flex-column align-items-center px-4 py-5 surface-100 shadow-2 border-round-2xl"
          style={{ maxWidth: '400px', width: '100%' }}
        >
          <div className="text-center mb-4">
            <img
              src="/assets/marsi-azul-degradado-fondo-blanco.webp"
              style={{ width: '293px' }}
              alt="Logotipo de Marsinet"
            />
          </div>
          <div className="mt-6 mb-5 font-bold text-3xl text-900 text-center">
            {t('pages.registerAccount.registerTitle') ?? '¡Cuenta registrada!'}
          </div>
          <p className="text-700 text-xl mt-0 mb-6 text-center">
            {t('pages.registerAccount.registerDescription')}
          </p>
          <div className="text-center w-full">
            <button
              type="button"
              className="p-button p-component p-button-secondary "
              onClick={() => navigate('/login')}
            >
              {t('pages.registerAccount.backToLogin')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountRegistered;
